/**
 * 身份态工具(rbac-visibility §一,身份 4 态机)。
 * 「已实名」= identityState ∈ {KYC_VERIFIED, WITHDRAW_BOUND}(单向不可逆,后者已越过 KYC)。
 * 供发布(W-7)/卖家管理(W-8)进屏 KYC 门禁与 KYC 页(W-2)已实名短路复用。
 */
export const KYC_VERIFIED_STATES = new Set(['KYC_VERIFIED', 'WITHDRAW_BOUND']);

export function isKycVerified(identityState: string | null | undefined): boolean {
  return !!identityState && KYC_VERIFIED_STATES.has(identityState);
}
